import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M16.471 6.5H5.783a2.999 2.999 0 0 0-2.781 1.876L1.2 12.835V8.832l.664-1.644a3.44 3.44 0 0 1 .53-.897 3.51 3.51 0 0 1 1.433-1.048A3.502 3.502 0 0 1 5.109 5H15c0-.825-.675-1.5-1.5-1.5H11V2A1.5 1.5 0 0 0 9.5.5h-4A1.5 1.5 0 0 0 4 2v1.5H1.5C.675 3.5 0 4.175 0 5v11.166l.01-.005c.042.717.626 1.34 1.413 1.34h11.868c.58 0 1.101-.352 1.318-.889l3.252-8.049a1.5 1.5 0 0 0-1.39-2.063zM5.2 2a.3.3 0 0 1 .3-.3h4a.3.3 0 0 1 .3.3v1.5H5.2V2z" />
  </svg>
);

export default SvgComponent;
